// import '../style/app.css';

import qrcode from 'qrcode-generator';

window.qrcode = qrcode;

import '../style/main.scss';

import 'babel-polyfill';

import jQuery from 'jquery';

window.jQuery = jQuery;
import 'jquery-ui/ui/widgets/sortable';
import Selectize from 'selectize';

window.Selectize = Selectize;
import moment from 'moment-timezone';
window.moment = moment;

window.dd = console.log;

let pdfjsLib = require('pdfjs-dist');
pdfjsLib.GlobalWorkerOptions.workerSrc = 'pdf.worker.bundle.js';
window.pdfjsLib = pdfjsLib;

import _ from 'lodash';
import Dropzone from 'dropzone';
Dropzone.autoDiscover = false;

window._ = _;
import 'quill';

// Import Ace Editor
require('ace-builds/src-min-noconflict/ace');
require('ace-builds/src-min-noconflict/ext-language_tools');
require('ace-builds/src-min-noconflict/theme-chrome');
require('ace-builds/src-min-noconflict/mode-html');
require('ace-builds/src-min-noconflict/mode-twig');
require('ace-builds/src-min-noconflict/mode-json');
require('ace-builds/src-min-noconflict/snippets/html');
require('ace-builds/src-min-noconflict/snippets/twig');

require('qrcode-generator/qrcode_UTF8');

jQuery.fn.textWidth = function (text, font) {
    if (!jQuery.fn.textWidth.fakeEl) jQuery.fn.textWidth.fakeEl = jQuery('<span>').hide().appendTo(document.body);
    jQuery.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));
    return jQuery.fn.textWidth.fakeEl.width();
};

// import tempates
//@require "./**/*.html"

const MODULE_NAME = 'festzelt-os';
export default MODULE_NAME;

require('./app-module.js');



// WEBPACK FOOTER //
// ./src/app/app.js